import { useQuery } from "@tanstack/react-query";
import { BatteryPlus } from "lucide-react";
import type { FC } from "react";
import React from "react";

import type { Identity, UserId } from "@core/domains/identity";

import { Button } from "@react/ui-primitives/button";
import { Skeleton } from "@react/ui-primitives/skeleton";

import { useQueries } from "../../../shared/hooks/useQueries.ts";

import { TopUpDialog } from "./TopUpDialog.tsx";

interface UserBalanceSummaryProps {
  readonly identities: readonly Identity[];
  readonly principalId: UserId;
}

export const UserBalanceSummary: FC<UserBalanceSummaryProps> = ({
  identities,
  principalId,
}) => {
  const { getBalanceQueryOptions } = useQueries();
  const balance = useQuery(getBalanceQueryOptions({ principalId }));

  if (balance.status !== "success") {
    return <Skeleton deferred variant="text-label" />;
  }

  return (
    <div className="flex items-center gap-2">
      <span className="font-mono text-sm whitespace-nowrap tabular-nums">
        ${balance.data.total}
      </span>
      <TopUpDialog
        activator={
          <Button size="icon-sm" variant="ghost">
            <BatteryPlus className="text-primary" />
          </Button>
        }
        identities={identities}
        principalId={principalId}
      />
    </div>
  );
};
